import React from 'react';

import FileItem from './FileItem/FileItem';

import { EmailFileEntry } from '../../../types';

type EmailEntryFilesProps = {
  emailEntryFiles: EmailFileEntry[];
};

const EmailEntryFiles = ({ emailEntryFiles }: EmailEntryFilesProps) => {
  return (
    <React.Fragment>
      {/* To Do: Convert to Table component */}
      <table className="printTableContainer">
        <tbody>
          <tr>
            <td colSpan={2}>
              <p>
                <strong>Attachment/s</strong>
              </p>
              <hr className="line-divider" />
            </td>
          </tr>
          <tr className="tr-divider">
            <td colSpan={2}>
              {/* inner table for attachments list */}
              <table className="printTableContainer">
                <tbody>
                  {emailEntryFiles.map((file) => (
                    <FileItem key={file.file.id} file={file} />
                  ))}
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    </React.Fragment>
  );
};

export default EmailEntryFiles;
